import { gql } from '@apollo/client';

export const GET_TECHNIQUES = gql`
  query techniques {
    techniques(
      criteria: { pagination: { page: 1, perPage: 100 } }
    ) {
        items {
            _id
            name
            description
            color
            durations
            order
            image 
            humanReadableId
          }
          meta {
            total
          }
    }
  }
`;

export const GET_BREATHING_SOUNDS = gql`
  query settingVariables {
    settingsVariables(
      criteria: { pagination: { page: 1, perPage: 100 } }
    ) {
      items {
       lauraBreatheIn
       lauraBreatheOut
       lauraHold
       paulBreatheIn
       paulBreatheOut
       paulHold
       bellBreatheIn
       bellBreatheOut
       bellHold
      }
    }
  }
`;